<sc-dummy></sc-dummy>
<ng-container *ngIf="authGuardService.user">
    <sc-supported-browsers-modal></sc-supported-browsers-modal>
</ng-container>
<ng-container *ngIf="authGuardService.user && shouldDisplayUnsupportedBrowserAlert()">
    <alert type="info" [dismissible]="true" class="unsupported-browser" (onClosed)="closeUnsupportedBrowserAlert()">
        <span class="caption">
            <span class="mobile-hidden">Parece que estás usando un navegador no soportado. </span>Para una mejor
            experiencia, te recomendamos utilizar <strong><a href="https://www.google.com/chrome/"
                    target="_blank" rel="noopener noreferrer">Chrome</a></strong>.
        </span>
    </alert>
</ng-container>
<div class="body" [class.withHeader]="showHeader && !showSB" [class.showSB]="showSB && authGuardService.user && !hideSideBarMenu && showCompleteMenu">
    <sc-notification *ngIf="isNotificationOpened" (onHandleCloseNotification)="onHandleCloseNotification()"></sc-notification>
    <div class="panel-left no-print" *ngIf="authGuardService.user && showSB && showCompleteMenu">
        <sc-main-side-bar [showSB]="showSB"
                     [state]="state"
                     [claimLink]="claimLink"
                     [sbData]="sbData"
                     [url]="url"
                     [hideSideBarMenu]="hideSideBarMenu"
                     [isNotificationOpened]="isNotificationOpened"
                     (onGoTo)="goTo($event)"
                     (onHandleNotificationBellClick)="onHandleNotificationBellClick($event)">
        </sc-main-side-bar>
    </div>
    <div class="panel-center app-content sc-scroll-bar" [ngClass]="{ 'scrolleable': isScrolleable }">
        <router-outlet (activate)="updateMenu($event)"></router-outlet>
        <sc-lateral-menu-wrapper *ngIf="authGuardService.user"
            id="home-lateral-menu-wrapper"
            [isOpen]="isMenuLateralOpen && showLateralMenu"
            [loading]="loadingQuotation"
            (closeModal)="closeLateralMenu()">
                <sc-branch-selector
                    *ngIf="insuranceCoreName && !selectedBranch && !loadingQuotation && showBranchSelector"
                    [rowData]="branchItems"
                    [runAnimation]="isMenuLateralOpen"
                    (onClick)="handleBranchSelected($event)"
                ></sc-branch-selector>
                
                <sc-category-selector
                    *ngIf="insuranceCoreName && showCategorySelector && selectedBranch && !selectedCategory && !loadingQuotation && showBranchSelector"
                    [backToBranchLabel]="selectedBranch.text"
                    [backToBranchIconSrc]="selectedBranch.icon"
                    [rowData]="categoryItems"
                    (onClick)="handleCategorySelected($event)"
                    (backToBranchClick)="returnToBranchSelector($event)"
                ></sc-category-selector>
                
                <sc-pas-selector
                    *ngIf="insuranceCoreName && !!selectedBranch && (!showCategorySelector || !!selectedCategory) && !loadingQuotation"
                    [backToBranchLabel]="selectedBranch.text"
                    [backToBranchIconSrc]="selectedBranch.icon || ''"
                    [runAnimation]="!!selectedBranch"
                    [rowData]="producers"
                    (backToBranchClick)="returnToBranchSelector($event)"
                    (onClick)="handleOnPasClick($event)"
                ></sc-pas-selector>
        </sc-lateral-menu-wrapper>
    </div>
</div>
<sc-snack-bar [(trigger)]="showSBNotification"
              [message]="SBMessage"
              [action]="SBAction"
              [title]="SBTitle"></sc-snack-bar>
